module.exports = __webpack_public_path__ + "static/media/report-clipboard.4c20639a.svg";